import Wrapper from "../../../layout/Wrapper";
import UserPermissionManageComponent from "../../../screens/settings/user-permission/manage";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "User Permission Management",
	description: "",
};

export default function UserPermissionManage() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<UserPermissionManageComponent />
		</Wrapper>
	);
}